import React from 'react';
import Greet from './Images/Greet.svg';

function GreetSection() {
  return(
    <div className="container-fluid greet-section">
        <div className="row">
            <div className="col-md-6">
              <div className="intro-text">
                  <h1>Hello I am <strong>Muhammad Yaseen</strong></h1>
                  <p>I am professional Front End & Wordpress developer.</p>
              </div>
              <div className="social-media">
                  <a href="https://www.linkedin.com/in/yaseen-ahmed-42b78b131/"><i className="fa fa-linkedin"></i></a>
                  <a href="mailto:yaseenmighty86@gmail.com"><i className="fa fa-google"></i></a>
                  <a href="https://www.facebook.com/profile.php?id=100004608039582"><i className="fa fa-facebook"></i></a>
              </div>
            </div>
            <div className="col-md-6">
              <div className="greeting-image-div">
                <img src={Greet} alt="Greet" className="img-fluid animated" />
              </div>
              
            </div>
        </div>  
    </div>
  );
}

export default GreetSection;

